import { render, staticRenderFns } from "./AsiPageTitle.vue?vue&type=template&id=4c90d2f2&scoped=true"
import script from "./AsiPageTitle.vue?vue&type=script&lang=ts"
export * from "./AsiPageTitle.vue?vue&type=script&lang=ts"
import style0 from "./AsiPageTitle.vue?vue&type=style&index=0&id=4c90d2f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c90d2f2",
  null
  
)

export default component.exports